// extracted by mini-css-extract-plugin
export var quantityInput = "_gr-0";